import React from "react";

function SectionWhatIsHumanizerQA() {
  return (
    <div className="container" style={{ marginTop: "7rem" }}>
      {/* question section */}
      <div>
        {/* How to humanize heading */}
        <h1 className="display-6">What is an AI humanizer?</h1>
      </div>

      <div className="row">
        {/* answer section */}
        <div className="col-lg-8 col-sm-12">
          {/* How to humanize heading */}
          <p className="lead mt-3">
            An AI text humaniser is a program that modifies or rewrites texts
            from ChatGPT, Grammarly, QuillBot,Bard, Jasper, or other AI text generators to make it
            sound more engaging, human, and natural. By incorporating
            conversational language, emotional nuance, and context-appropriate
            phrasing, it enhances tone, flow, and clarity. This is particularly
            helpful for making AI-generated content feel more relatable and
            simpler for people to comprehend and relate to, like emails, chatbot
            responses, articles, research papers, or social media posts.
          </p>
          <p className="lead">
            You can paraphrase each word, sentence, or paragraph individually using this
            AI text humanizer. It is designed to help you bypass AI detectors
            and plagiarism checkers, ensuring that the text appears as if it was
            written by a human. <strong>This AI text converter is the best available for
            free online, allowing you to achieve 100% human-like text with ease.</strong>
            </p>
        </div>

        {/* image section */}
        <div className="col-lg-4 col-sm-12 d-none d-lg-block">
          <img
            src="./images/ai_humanizer.jpg"
            alt="AI Humanizer"
            className="img-fluid rounded shadow-sm object-fit-cover"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
}

export default SectionWhatIsHumanizerQA;
